import { Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const LeftControls = styled(Stack)(({ theme }) => ({
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
}));
export const CaptionBold = styled(Typography)({
  fontWeight: 600,
});
export const RightCaption = styled(Typography)(({ theme }) => ({
  paddingRight: theme.spacing(1),
  fontWeight: 600,
}));
